import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { SearchTypes } from '../../constants/CentricConstants';
import { formatName } from '../../utils/StringUtils';

import AutoComplete from '../Common/AutoComplete';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import UserActions from '../../actions/UserActionCreator';
import SearchStore from '../../stores/SearchStore';

const userListItem = (user) => {
    const name = formatName(user);
    return {
        key:    user.id,
        text:   name,
        value:  <MenuItem key={user.id} value={user.id} primaryText={name} />,
        user
    };
};

class EventAttendanceDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
    }

    render() {
        return (
            <Dialog
                title={this.props.title}
                open={true}
                modal={false}
                onRequestClose={this.props.onClose}
                actions={[
                    <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel}/>,
                    <FlatButton key="submit" label="Submit" onTouchTap={this.onSave} disabled={!this.state.draft.userId}/>
                ]}
            >
                <AutoComplete
                    floatingLabelText="User *"
                    maxSearchResults={5}
                    dataSource={this.state.results.map(userListItem)}
                    onUpdateInput={this.onUserAutocomplete.bind(this)}
                    onNewRequest={this.onUserSelect.bind(this)}
                    isFetching={this.state.isFetching}
                />
                {this.props.attendanceLocked ? <span><br /><em>User will be added to the waiting list</em></span> : (
                    <div className="cent-checkbox-wrapper">
                        <Checkbox
                            label="Add to waiting list"
                            defaultChecked={false}
                            onCheck={(e, value) => DialogActions.updateDraft('addToWaitingList', value)}
                        />
                    </div>
                )}
            </Dialog>
        );
    }


    onUserAutocomplete(input) {
        !!this.timeout && clearTimeout(this.timeout);
        if (input !== undefined && input.length >= 3) {
            this.timeout = setTimeout(function() { UserActions.search(input, {limit: 10}); }, 500);
        }
    }

    onUserSelect({user}) {
        if (!!user && user.id !== this.state.draft.userId) {
            DialogActions.bulkUpdateDraft({userId: user.id, title: user.title, firstName: user.firstName, lastName: user.lastName, role: 'delegate'});
        }
    }

    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }
}

EventAttendanceDialog.getStores = () => ([SearchStore, DialogStore]);
EventAttendanceDialog.calculateState = (prevState) => {
    const {open, draft} = DialogStore.getState();
    return {
        ...prevState,
        open,
        draft,
        results:    SearchStore.getResults(SearchTypes.USERS) || [],
        isFetching: SearchStore.isFetching(SearchTypes.USERS)
    };
};
EventAttendanceDialog.propTypes = {
    title:          PropTypes.string,
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool,
    attendanceLocked: PropTypes.bool
};

EventAttendanceDialog.defaultProps = {
    title:          'Add Attendee',
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true,
    attendanceLocked: false
};

export default Container.create(EventAttendanceDialog);
